module.exports = __webpack_public_path__ + "static/media/gift.aca6e700.svg";